import gql from "graphql-tag";

export const CreateTournament = gql`
  mutation CreateTournament($input: CreateTournamentInput!) {
    createTournament(input: $input) {
      competitionId
      beginTime
      lunchBeginTime
      lunchEndTime
      area
      sector
      timeOffsetInMinutes
      hasMatches
      i18n_comments
    }
  }
`;

// export const UpdateTournament = gql`
//   mutation UpdateTournament($input: UpdateTournamentInput!) {
//     updateTournament(input: $input) {
//       competitionId
//       beginTime
//       lunchBeginTime
//       lunchEndTime
//       area
//       sector
//       timeOffsetInMinutes
//       hasMatches
//     }
//   }
// `;

export const CreateScheduleItem = gql`
  mutation CreateScheduleItem($input: CreateScheduleItemInput!) {
    createScheduleItem(input: $input) {
      matchId
      matchType
      competitionId
      teamId
      userId
      group
      attempt
      beginTime
      endTime
      resultUnit
    }
  }
`;

export const ListScheduleItems = gql`
query ListScheduleItems($competitionId: ID!, $limit: Int, $nextToken: String) {
  listScheduleItems(competitionId: $competitionId, limit: $limit, nextToken: $nextToken) {
    nextToken
    items {
      id
      matchId
      matchType
      competitionId
      teamId
      technicalControl {
        status
        comments
      }
      name
      robotName
      robotNumber
      group
      attempt
      beginTime
      endTime
      result
      resultUnit
    }
  } 
}
`;

export const GetCompetition = gql`
  query GetCompetition($eventId: ID!, $competitionId: ID!) {
    getCompetition(eventId: $eventId, competitionId: $competitionId) {
      competitionId
      code 
      date 
      competitionType
      attemptsLimit
      attemptMaxLengthInSeconds
      concurrentCompetitors
      rrtCompetitorsInGroupMin
      rrtCompetitorsInGroupMax
      rrtCompetitorsInGroupAdvancing
      rrtConcurrentGroups
      rrtConcurrentGroupGames
      tournament {
        competitionId
        beginTime
        lunchBeginTime
        lunchEndTime
        area
        sector
        timeOffsetInMinutes
        hasMatches
        i18n_comments
      }
    }
  }
`;

export const ListTeams = gql`
query ListTeams($filter: TableTeamFilterInput, $limit: Int, $nextToken: String) {
  listTeams(filter: $filter, limit: $limit, nextToken: $nextToken) {
    nextToken
    items {
      competitionId
      teamId
      userId
      name
      robotName
      robotNumber
      purchaseOrders {
        purchaseOrderId
        status
      }
      payments {
        paymentId
        voistlus
        success
        total
      }
      technicalControl {
        status
      }
    }
  } 
}
`;



// WEBPACK FOOTER //
// ./src/private/admin/containers/Tournaments/graphql.js